import { WEEK_DAYS } from 'constants/myTeam';

export const getRosterWeekDay = (workDate: string | undefined, index: number) => {
  if (workDate) {
    const date = new Date(workDate);

    if (!Number.isNaN(date.getTime())) {
      const weekDay = date.toLocaleDateString('en-US', { weekday: 'long' });

      if (weekDay) {
        return weekDay;
      }
    }
  }

  return WEEK_DAYS[index] || WEEK_DAYS[0];
};
